export enum MessageAction {
    SEND_ONLY = "SEND_ONLY",
    SEND_AND_AWAIT_FEEDBACK = "SEND_AND_AWAIT_FEEDBACK",
    SEND_AND_CLOSE = "SEND_AND_CLOSE"
}